import PaletteSwap from "@frog/source/engine/animating/utility/PaletteSwap.js"

export default class Preload {
    constructor(preload) {
        this.images = preload.images || []
        this.audio = preload.audio || []

        this.loadedImageCount = 0
        this.totalImageCount = Object.values(this.images).length

        this.loadedAudioCount = 0
        this.totalAudioCount = 0

        window.frog = window.frog || {}
        window.frog.preload = this

        this.callbacks = []

        Object.values(this.images).forEach((image) => {
            image.element = new Image()
            image.element.src = image.url
            image.element.addEventListener("load", () => {
                image.element.isLoaded = true

                if(image.callback != undefined) {
                    image.callback(image)
                    delete image.callback
                }

                // if(image.paletteKeys != undefined) {
                //     image.palettes = {}
                //     image.paletteKeys.forEach((paletteKey) => {
                //         image.palettes[paletteKey] = PaletteSwap({
                //             "imageElement": image.element,
                //             "paletteKey": paletteKey
                //         })
                //     })
                // }

                image.isLoaded = true
                this.loadedImageCount += 1

                if(this.loadedImageCount >= this.totalImageCount) {
                    this.callbacks.forEach((callback) => callback())
                }
            })
        })
    }
    get isLoading() {
        // if(audiotriggers["Hell:Opening:Music"].readyState < 4) return true
        // if(audiotriggers["Hell:Opening:Narration"].readyState < 4) return true
        if(document.fonts.check("12px base") == false) return true
        if(document.fonts.check("12px header") == false) return true
        if((this.loadedImageCount / this.totalImageCount) < 1) return true
        if((this.loadedAudioCount / this.totalAudioCount) < 1) return true
        return false
    }
    get totalCount() {
        return this.totalAudioCount + this.totalImageCount
    }
    get loadedCount() {
        return this.loadedAudioCount + this.loadedImageCount
    }
    onLoad(callback) {
        if(this.isLoading == true) {
            this.callbacks.push(callback)
        } else {
            callback()
        }
    }
    load({audios, images}) {
        // TODO: support the preloading of images as well!!

        if(audios != undefined) {
            Object.values(audios).forEach((audio) => {
                if(audio.mustBeLoaded != true) {
                    this.loadedAudioCount += 1
                    return
                }
                if(audio instanceof Audio
                && audio.readyState < 4) {
                    audio.addEventListener("canplay", (event) => {
                        this.loadedAudioCount += 1
                        audio.isLoaded = true
                    })
                    audio.load()
                    return
                }
                if(audio.audio != undefined
                && audio.audio instanceof Audio
                && audio.audio.readyState < 4) {
                    audio.audio.addEventListener("canplay", (event) => {
                        this.loadedAudioCount += 1
                        audio.audio.isLoaded = true
                    })
                    this.totalAudioCount += 1
                    audio.audio.load()
                    return
                }
                if(audio.audio != undefined
                && audio.audio instanceof Array) {
                    audio.audio.forEach((subaudio) => {
                        if(subaudio instanceof Audio
                        && subaudio.readyState < 4) {
                            subaudio.addEventListener("canplay", (event) => {
                                this.loadedAudioCount += 1
                                subaudio.isLoaded = true
                            })
                            this.totalAudioCount += 1
                            subaudio.load()
                        }
                    })
                }
            })
        }
    }
}
